import {StyleSheet} from 'react-native';

import {mineShaft} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
  view: {
    paddingHorizontal: 5,
    marginVertical: -7,
  },
  text: {
    color: mineShaft,
    fontFamily: 'Muli',
    fontSize: 16,
    lineHeight: 24,
  },
  dot: {
    marginVertical: 3,
  },
});
